module.exports = __webpack_public_path__ + "static/006-slideshow-ee29130b2f9bce71efd3aa35f991f35a.jpg";